import type { RESIDUAL_DEBT_INSURANCE } from 'cpool-constants';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { SchemaCreditRequestForm } from '../schemas/creditRequestForm.schema';
import { FormBooleanSegmentedControl } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormBooleanSegmentedControl';

const INSURANCE_PATHS = {
    DEATH: 'death',
    UNEMPLOYMENT: 'unemployment',
    WORK_INCAPACITY: 'workIncapacity',
} as const satisfies Record<RESIDUAL_DEBT_INSURANCE, string>;

const QUESTIONS = [
    { field: 'existing', label: 'EXISTING' },
    { field: 'important', label: 'IMPORTANT' },
    { field: 'desired', label: 'DESIRED' },
] as const;

type Props = {
    applicant: 'applicant1' | 'applicant2';
    insurance: RESIDUAL_DEBT_INSURANCE;
};

export const InsuranceCard: React.FC<Props> = ({ applicant, insurance }) => {
    const { t } = useTranslation();
    const { control } = useFormContext<SchemaCreditRequestForm>();

    return (
        <div className="flex flex-col gap-2 rounded-md border border-grey-outline-light p-3">
            <p className="text-sm font-bold text-midnight">
                {t(`BANK_CREDIT_REQUEST.RESIDUAL_DEBT_INSURANCE.TABLE_SIDE_HEADERS.${insurance}`)}
            </p>
            {QUESTIONS.map(({ field, label }) => (
                <FormBooleanSegmentedControl
                    key={field}
                    control={control}
                    id={`restschuldversicherung.${applicant}.${INSURANCE_PATHS[insurance]}.${field}`}
                    label={t(`BANK_CREDIT_REQUEST.RESIDUAL_DEBT_INSURANCE.QUESTIONS.${label}`)}
                    labelClassName="h-8 w-28 shrink-0 justify-start"
                />
            ))}
        </div>
    );
};
